import { pick } from 'ramda';
import { useCallback } from 'react';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

export const useFilterByRoleAvailability = () => {
    const { isLoggedIn } = useUserSelector(pick(['isLoggedIn']));
    const { isAdminLoggedIn, isQuickDepositAvailable, quickDepositPage } = useAppSelector(pick(['isAdminLoggedIn', 'isQuickDepositAvailable', 'quickDepositPage']));

    return useCallback((items) => items.filter((item) => {
            const isGuestRole = item?.roles?.includes('GUEST');
            const isUserRole = item?.roles?.includes('USER');

            const isPermitted = isAdminLoggedIn
                || isGuestRole && !isUserRole && !isLoggedIn
                || isUserRole && !isGuestRole && isLoggedIn
                || isUserRole && isGuestRole;

            return isPermitted && !(item.url === quickDepositPage && !isQuickDepositAvailable);
        }
    ), [isLoggedIn, isAdminLoggedIn, isQuickDepositAvailable, quickDepositPage]);
};
